<template>
    <div>
        <Row style="margin-bottom:20px">
            <Button type="primary" @click="add">添加回访方式</Button>
        </Row>
        <Table stripe :width="600" :loading="loading" border :columns="t_head" :data="t_data"></Table>
        <Modal
            v-model="ModalShow"
            :title="title">
            <Form ref="formValidate" :model="formItem" :rules="ruleValidate" :label-width="80">
                <FormItem label="回访方式" prop="return_info">
                    <Input v-model="formItem.return_info" placeholder="请输入" @keydown.native.enter.prevent ="handleEnter"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="close">取消</Button>
                <Button type="primary" size="large" @click="handleSubmit ('formValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'returnModeSetting',
    data(){
        return{
            loading:false,
            ModalShow:false,
            title:'',
            formItem:{
                return_info:"",
                type:"1"
            },
            ruleValidate:{
                return_info: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ]
            },
            t_head: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center',
                    title:"序号"
                },
                {
                    title: '回访方式',
                    key: 'return_info',
                    align: 'center',
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.row.id)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            t_data: [],
            listDetail:{}
        }
    },
    created(){
        this.apiReturnList()
    },
    methods:{
        handleEnter(){
            return false;
        },
        apiReturnList(){
            this.loading = true
            serve.fetchGet(api.returnWay,{}).then(data => {
                console.log(data)
                this.t_data = data.return_settings
                this.loading = false
            }).catch((error)=>{
                this.loading = false
                this.$Message.error(error.response.data.message);
            })
        },
        apiReturnAdd(){
            serve.fetchPost(api.returnWay,this.formItem).then(data => {
                console.log(data)
                this.$Message.success('添加成功')
                this.ModalShow = false
                this.apiReturnList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiReturnEdit(){
            serve.fetchPut(api.returnWay+"/"+this.listDetail.id,{return_info:this.formItem.return_info}).then(data => {
                console.log(data)
                this.$Message.success('编辑成功')
                this.ModalShow = false
                this.apiReturnList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiReturnRemove(id){
            serve.fetchDelete(api.returnWay+"/"+id,{}).then(data => {
                console.log(data)
                this.$Message.success('删除成功')
                this.apiReturnList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        add(){
            this.$refs.formValidate.resetFields()
            this.title = "添加回访方式"
            this.ModalShow = true
        },
        edit(row){
            this.$refs.formValidate.resetFields()
            this.title = "修改回访方式"
            this.ModalShow = true
            this.formItem.return_info = row.return_info
            this.listDetail = row
        },
        remove(id){
            this.apiReturnRemove(id)
        },
        close(){
            this.ModalShow = false
        },
        handleSubmit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if(this.title === '添加回访方式'){
                        this.apiReturnAdd()
                        return
                    }
                    this.apiReturnEdit()
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/Crm/ReturnManagement/returnModeSetting.vue